import {
  Component,
  ElementRef,
  ChangeDetectionStrategy,
  booleanAttribute,
  input,
  viewChild,
} from '@angular/core';

import { DialogBodyComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'reports-library-dialog-layout',
  templateUrl: './library-dialog-layout.component.html',
  styleUrls: ['./library-dialog-layout.component.less'],
  standalone: true,
  imports: [DialogBodyComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportsLibraryDialogLayoutComponent {
  protected readonly topAreaRef = viewChild<ElementRef<HTMLElement>>('topArea');

  protected readonly scrollContainer =
    viewChild.required<ElementRef<HTMLElement>>('scrollContainer');

  public readonly scrollableSidebar = input(false, { transform: booleanAttribute });

  public scrollToTop(): void {
    const el = this.scrollContainer().nativeElement;
    el.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }
}
